/**
 * Phase 6 — chapter navigation from index (no hardcoded chapters).
 */
export function GitaChapterNav({ chapters = [], activeChapter, onSelect }) {
  if (!chapters.length) return null;

  return (
    <nav
      className="flex flex-wrap gap-2 mb-6 sticky top-20 z-10 bg-background/80 backdrop-blur py-2"
      aria-label="Gītā chapters"
      data-testid="gita-chapter-nav"
    >
      {chapters.map((ch) => {
        const num = ch.chapter ?? ch;
        const title = ch.title ?? `Chapter ${num}`;
        const isActive = activeChapter === num;
        return (
          <button
            key={num}
            type="button"
            onClick={() => onSelect?.(num)}
            className={`text-xs px-2 py-1 rounded border transition-colors ${
              isActive
                ? "bg-primary text-primary-foreground border-primary"
                : "bg-white/80 text-muted-foreground border-border hover:border-primary/50"
            }`}
            data-testid={`gita-chapter-btn-${num}`}
          >
            {num}. {title.length > 28 ? `${title.slice(0, 26)}…` : title}
          </button>
        );
      })}
    </nav>
  );
}
